if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        if (!this.cart && document.querySelector('.cart')) {
          this.cart = document.querySelector('.cart');
        }
        
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.lp-btn-text') || this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Check initial cart state
        this.checkCartState();
        
        // Subscribe to cart updates to refresh quantity display
        this.setupCartUpdateListener();
      }
      
      setupCartUpdateListener() {
        // Use custom event listeners that we control
        const handleCartUpdate = () => {
          console.log('ProductForm: received cart update, checking cart state');
          this.checkCartState();
        };
        
        document.addEventListener('cartUpdate', handleCartUpdate);
        document.addEventListener('cart:added', handleCartUpdate);
        document.addEventListener('cart:refresh', handleCartUpdate);
        
        // Also try pub/sub if available
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          console.log('ProductForm: subscribing to PUB_SUB_EVENTS.cartUpdate');
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
        } else {
          console.log('ProductForm: subscribe not available, using fallback');
          // Fallback: try again after a short delay
          setTimeout(() => {
            if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              console.log('ProductForm: subscribing to PUB_SUB_EVENTS.cartUpdate (delayed)');
              this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
            }
          }, 100);
        }
        
        // Also poll cart state as fallback - check every 2 seconds
        this._cartPollInterval = setInterval(() => {
          this.checkCartState();
        }, 2000);
        
        // Store for cleanup
        this._cartUpdateHandler = handleCartUpdate;
      }
      
      disconnectedCallback() {
        if (this._cartPollInterval) {
          clearInterval(this._cartPollInterval);
        }
        if (this._cartUpdateHandler) {
          document.removeEventListener('cartUpdate', this._cartUpdateHandler);
          document.removeEventListener('cart:added', this._cartUpdateHandler);
          document.removeEventListener('cart:refresh', this._cartUpdateHandler);
        }
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }
      
      checkCartState() {
        const variantId = this.dataset.variantId;
        if (!variantId) {
          return;
        }
        
        fetch('/cart.js', { cache: 'no-store' })
          .then(res => res.json())
          .then(cart => {
            const item = cart.items.find(i => String(i.variant_id) === String(variantId));
            const currentQty = item ? item.quantity : 0;
            
            if (currentQty > 0) {
              // Update existing quantity controls or show them
              const existingDisplay = this.submitButton?.querySelector('.lp-qty-display');
              if (existingDisplay) {
                existingDisplay.textContent = `${currentQty} in winkelwagen`;
              } else {
                this.showQuantityControlsOnButton(currentQty);
              }
            } else {
              // Item no longer in cart - reset button
              if (this.submitButton.classList.contains('lp-has-qty')) {
                this.resetToAddButton();
              }
            }
          })
          .catch(() => {});
      }
      
      resetToAddButton() {
        this.submitButton.innerHTML = `
          <span class="lp-btn-text">Aan winkelwagen toevoegen</span>
          <span class="sold-out-message hidden">Uitverkocht</span>
          <div class="loading__spinner hidden">
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
            </svg>
          </div>
        `;
        this.submitButton.setAttribute('type', 'submit');
        this.submitButton.classList.remove('lp-has-qty');
        this.submitButton.classList.add('button--secondary', 'button--full-width');
        this.submitButton.style.cssText = '';
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
      }
      
      showQuantityControlsOnButton(quantity) {
        console.log('Showing quantity controls:', quantity);
        
        // Clear any existing state that might prevent clicking
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.removeAttribute('disabled');
        
        // Create a completely new wrapper with fresh styles
        const wrapper = document.createElement('div');
        wrapper.className = 'lp-qty-wrapper';
        wrapper.style.cssText = `
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
        `;
        
        // Create minus button - outline style by default, filled on hover
        const minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'lp-qty-btn lp-qty-minus';
        minusBtn.textContent = '−';
        minusBtn.style.cssText = `
          background: transparent !important;
          border: 2px solid #fd6ca8 !important;
          color: #fd6ca8 !important;
          font-size: 1.5rem !important;
          font-weight: 700 !important;
          width: 44px !important;
          height: 44px !important;
          border-radius: 50% !important;
          cursor: pointer !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
          box-shadow: none !important;
          outline: none !important;
          transition: all 0.2s ease !important;
          transform: translateY(0) !important;
        `;
        
        // Add hover styles via mouseenter
        minusBtn.onmouseenter = function() {
          this.style.cssText += 'background: #fd6ca8 !important; color: #fff !important;';
        };
        minusBtn.onmouseleave = function() {
          this.style.cssText = `
            background: transparent !important;
            border: 2px solid #fd6ca8 !important;
            color: #fd6ca8 !important;
            font-size: 1.5rem !important;
            font-weight: 700 !important;
            width: 44px !important;
            height: 44px !important;
            border-radius: 50% !important;
            cursor: pointer !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            flex-shrink: 0 !important;
            box-shadow: none !important;
            outline: none !important;
            transition: all 0.2s ease !important;
            transform: translateY(0) !important;
          `;
        };
        minusBtn.onclick = (e) => { e.preventDefault(); this.updateQuantity(-1); };
        
        // Create display
        const display = document.createElement('span');
        display.className = 'lp-qty-display';
        display.textContent = `${quantity} in winkelwagen`;
        display.style.cssText = `
          font-weight: 700 !important;
          font-size: 0.95rem !important;
          color: #2d2d2d !important;
          margin: 0 8px !important;
        `;
        
        // Create plus button - outline style by default, filled on hover
        const plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'lp-qty-btn lp-qty-plus';
        plusBtn.textContent = '+';
        plusBtn.style.cssText = minusBtn.style.cssText;
        
        // Add hover styles via mouseenter
        plusBtn.onmouseenter = function() {
          this.style.cssText += 'background: #fd6ca8 !important; color: #fff !important;';
        };
        plusBtn.onmouseleave = function() {
          this.style.cssText = minusBtn.style.cssText;
        };
        plusBtn.onclick = (e) => { e.preventDefault(); this.updateQuantity(1); };
        
        wrapper.appendChild(minusBtn);
        wrapper.appendChild(display);
        wrapper.appendChild(plusBtn);
        
        // Replace button content with wrapper - completely override all button styles
        this.submitButton.innerHTML = '';
        this.submitButton.appendChild(wrapper);
        this.submitButton.classList.add('lp-has-qty');
        
        // Force remove all theme styling and ensure button is clickable
        this.submitButton.style.cssText = `
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          padding: 0 !important;
          transform: none !important;
        `;
        
        // Ensure button is enabled
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        
        // Also remove theme classes
        this.submitButton.classList.remove('button--secondary', 'button--full-width');
      }
      
      updateQuantity(change) {
        const variantId = this.dataset.variantId;
        const submitBtn = this.submitButton;
        const wrapper = submitBtn.querySelector('.lp-qty-wrapper');
        const currentBtn = wrapper ? wrapper.querySelector('.lp-qty-display') : null;
        
        if (!currentBtn) return;
        
        let qty = parseInt(currentBtn.textContent) + change;
        
        if (qty <= 0) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 0 })
          })
          .then(res => res.json())
          .then(() => {
            // Reset to original button - fully override styles
            // Include the loading spinner structure
            submitBtn.innerHTML = `
              <span class="lp-btn-text">Aan winkelwagen toevoegen</span>
              <span class="sold-out-message hidden">Uitverkocht</span>
              <div class="loading__spinner hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                  <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                </svg>
              </div>
            `;
            submitBtn.setAttribute('type', 'submit');
            submitBtn.classList.remove('lp-has-qty');
            submitBtn.classList.add('button--secondary', 'button--full-width');
            submitBtn.style.cssText = '';
            
            // FULLY re-enable button - this is critical
            submitBtn.removeAttribute('disabled');
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.removeAttribute('aria-label');
            submitBtn.style.pointerEvents = 'auto';
            submitBtn.style.opacity = '1';
            submitBtn.style.cursor = 'pointer';
            
            // Re-cache the button reference since we replaced innerHTML
            this.submitButton = this.querySelector('[type="submit"]');
            
            console.log('Button reset complete, should be clickable now');
          });
        } else {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          })
          .then(res => res.json())
          .then(() => {
            currentBtn.textContent = `${qty} in winkelwagen`;
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        
        // Log current button state for debugging
        console.log('Submit clicked, current state:', {
          ariaDisabled: this.submitButton.getAttribute('aria-disabled'),
          disabled: this.submitButton.hasAttribute('disabled'),
          type: this.submitButton.type,
          classList: this.submitButton.classList,
          pointerEvents: this.submitButton.style.pointerEvents
        });
        
        // Always remove ALL possible disable states before proceeding
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.removeAttribute('disabled');
        
        // Force re-enable the button completely
        this.submitButton.style.pointerEvents = 'auto';
        this.submitButton.style.opacity = '1';
        this.submitButton.style.cursor = 'pointer';
        
        // If already has quantity controls, increment
        if (this.submitButton.classList.contains('lp-has-qty')) {
          this.updateQuantity(1);
          return;
        }

        this.handleErrorMessage();

        // Check if button still has the spinner before trying to access it
        const spinner = this.querySelector('.loading__spinner');
        
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } 

            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
            
            // Show quantity controls on the submit button
            this.showQuantityControlsOnButton(1);
            
            // Update cart count in header and dispatch events for cart bubble
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                const cartCount = document.querySelector('#cart-count, .cart-count, [data-cart-count]');
                if (cartCount) cartCount.textContent = cart.item_count;
                document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart } }));
              })
              .catch(e => console.log('Error updating cart count:', e));
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
            }
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.add('hidden');
            }
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
